import React, { useContext } from 'react';

import Skeleton from './Skeleton';
import { LayoutContext } from '../../context/layoutContext';
import { Flex } from '../../styles/globalStyles';

const webRender = ['homeVod1', 'homeVod2', 'homeVod3', 'homeVod4', 'homeVod5', 'homeVod6'];
const mobileRender = ['homeVod1', 'homeVod2', 'homeVod3'];

const HomeVodSkeleton = () => {
  const { matchese } = useContext(LayoutContext);
  return (
    <Flex justifyContent='space-between' flexWrap='wrap' style={{ margin: '20px 0' }}>
      {matchese ? (
        <>
          {mobileRender.map((item, idx) => {
            let width = idx > 0 ? `${100 / 2}%` : `100%`;
            let height = idx > 0 ? `130px` : `190px`;

            return (
              <div key={item} style={{ width: width, padding: '3px' }}>
                <Skeleton type='box' height={height} margin='0 0 10px' />
                <Skeleton type='text' width='50%' margin='5px 0' />
                <Skeleton type='text' width='30%' margin='5px 0' />
              </div>
            );
          })}
        </>
      ) : (
        <>
          {webRender.map((item, idx) => {
            let width = idx > 1 ? `${100 / 4}%` : `${100 / 2}%`;
            let height = idx > 1 ? `130px` : `300px`;

            return (
              <div key={item} style={{ width: width, padding: '10px' }}>
                <Skeleton type='box' height={height} margin='0 0 10px' />
                <Skeleton type='text' width='50%' margin='5px 0' />
                <Skeleton type='text' width='30%' margin='5px 0' />
              </div>
            );
          })}
        </>
      )}
    </Flex>
  );
};

export default HomeVodSkeleton;
